export type MetricStatus = 'open' | 'closed';
export type MetricsView = 'Severity' | 'Timeband';

export const AGE_BANDS = [
  { key: '0_3', label: '0 to 3 Days', max: 3 },
  { key: '3_7', label: '3+ to 7 Days', min: 3, max: 7 },
  { key: '7_14', label: '7+ to 14 Days', min: 7, max: 14 },
  { key: '14_28', label: '14+ to 28 Days', min: 14, max: 28 },
  { key: '28_plus', label: '28+ Days', min: 28 },
] as const;

export type AgeBandKey = (typeof AGE_BANDS)[number]['key'];
export interface CycleMetric {
  count: number;
  total_age_seconds: number;
  bands: Record<AgeBandKey, number>;
}
export interface MetricsCell {
  provider: string;
  severity: number;
  open: CycleMetric;
  closed: CycleMetric;
}
export interface BPAMetricsData {
  generated_at: string;
  providers: { provider: string; name: string; integration_count: number }[];
  cells: MetricsCell[];
}
